import { parseUrlSearchParams } from 'mini-common-utils/lib/utils/parseUrlSearchParams';

/***
 * Allow for easy testing of the green room banner by setting showGreemRoom=true in the query params
 */
export function checkForGreenRoomQueryParam() {
    const search = window.location.search;
    const queryParams = parseUrlSearchParams(search);
    const greenRoom = search.includes('showGreenRoom') && queryParams['showGreenRoom'];
    if (greenRoom) {
        return true;
    }
    return false;
}
